var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "LoadingOverlay",
    {
      attrs: {
        loading: _vm.$apollo.queries.contractorUser.loading,
        hasData: !!_vm.contractorUser,
      },
    },
    [
      _c("ContractorManagerInformationProvider", {
        key: _vm.componentKey,
        attrs: { user: _vm.contractorUser },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({
              isRequestContractorShown,
              isContractorRequested,
              changeRequestStatus,
              contractorId,
            }) {
              return [
                _c("ContractorAbout", {
                  attrs: {
                    company: _vm.company,
                    contractorUser: _vm.contractorUser,
                    isContractorRequested: isContractorRequested,
                    isAccessGranted: _vm.isAccessGranted,
                    currentUserId: _vm.managerUserId,
                    isAdmin: _vm.isAdmin,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "optionalInfo",
                        fn: function () {
                          return [
                            isContractorRequested
                              ? _c("CardInfoChip", {
                                  attrs: { message: "Requested", green: "" },
                                })
                              : _vm._e(),
                            _vm.isAccessGranted
                              ? _c(
                                  "div",
                                  { staticClass: "flex" },
                                  [
                                    _c("CardInfoChip", {
                                      staticClass: "mr-3",
                                      attrs: { message: "Access Granted" },
                                    }),
                                    _c("ContractorFullInformationLink", {
                                      attrs: { contractorId: contractorId },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "actionButton",
                        fn: function () {
                          return [
                            isRequestContractorShown
                              ? _c("AddContractorToCompany", {
                                  attrs: {
                                    buttonText: "Request access",
                                    contractorId: contractorId,
                                    currentUserRole: _vm.roles.MANAGER,
                                    currentUserId: _vm.managerUserId,
                                    companyId: _vm.company.id,
                                    companyName: _vm.company.business_name,
                                    contractorUserId: _vm.contractorUserId,
                                    isPublic: _vm.isPublic,
                                    buttonVariant: "black",
                                    buttonSize: "lg",
                                    customHeading: "buttonTop",
                                    buttonClasses: "px-2 pr-4 pl-4",
                                  },
                                  on: {
                                    addedToCompany: function ($event) {
                                      return changeRequestStatus(true)
                                    },
                                    "update:isPublic": function ($event) {
                                      _vm.isPublic = $event
                                    },
                                    "update:is-public": function ($event) {
                                      _vm.isPublic = $event
                                    },
                                  },
                                })
                              : _vm._e(),
                            isContractorRequested
                              ? _c("RemoveManagerContractorRequest", {
                                  attrs: {
                                    contractorId: contractorId,
                                    managerId: _vm.currentUserManagerId,
                                    buttonVariant: "outline-black",
                                    buttonSize: "lg",
                                    customHeading: "buttonTop",
                                  },
                                  on: {
                                    requestRemoved: function ($event) {
                                      return changeRequestStatus(false)
                                    },
                                  },
                                })
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }